import axios from 'axios'

export const RESUME_ENDPOINTS = {
  otpGenerate: '/motor-assessment/api/claims/otp-generate',
  otpValidate: '/motor-assessment/api/claims/otp-validate',
}

export function generateResumeOtp({
  journeyResumeReference,
  regNo,
  phoneNumber,
}) {
  return axios.post(RESUME_ENDPOINTS.otpGenerate, {
    journeyResumeReference,
    regNo,
    phoneNumber,
  })
}

export function validateResumeOtp({
  journeyResumeReference,
  regNo,
  phoneNumber,
  otp,
}) {
  return axios.post(RESUME_ENDPOINTS.otpValidate, {
    journeyResumeReference,
    regNo,
    phoneNumber,
    otp,
  })
}
